
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { Client } from "@/types";
import { ActivityNotesList } from "./activity/ActivityNotesList";
import { ActivityEmpty } from "./activity/ActivityEmpty";
import { hasActivityData } from "./activity/activityUtils";

interface ClientActivitySectionProps {
  client: Client;
}

export const ClientActivitySection = ({ client }: ClientActivitySectionProps) => {
  return (
    <Card className="backdrop-blur-lg bg-white/10 border-white/20 h-full">
      <CardHeader>
        <CardTitle className="text-white">Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        {hasActivityData(client.notes) ? (
          <ActivityNotesList notes={client.notes} />
        ) : (
          <ActivityEmpty />
        )}
      </CardContent>
    </Card>
  );
};
